import { useReducer } from 'react'
import reducer, { CUSTOMER_TYPE_PRICE_INIT_STATE } from './CustomerTypePriceReducer';

const useCustomerTypePrice = () => {
    const [state, dispatch] = useReducer(reducer, CUSTOMER_TYPE_PRICE_INIT_STATE);
    const savePercentage = (type, percentage) => {
        dispatch({ type: 'save_percentage', payload: { type, percentage } });
    }
    const calculateAll = (cost, taxDecimal1, taxDecimal2) => {
        dispatch({
            type: 'calculate_all',
            payload: {
                cost, taxDecimal1, taxDecimal2, taxDecimalTotal: taxDecimal1 + taxDecimal2,
            },
        });
    }
    const calculateGeneral = (cost, taxDecimal1, taxDecimal2, basePrice, baseImporte) => {
        dispatch({
            type: 'calculate_general',
            payload: {
                cost, taxDecimal1, taxDecimal2, taxDecimalTotal: taxDecimal1 + taxDecimal2, basePrice, baseImporte
            },
        });
    }

    return [state, { savePercentage, calculateAll, calculateGeneral }];
}

export default useCustomerTypePrice;
